
export const onlypositivenumbers = (val) =>  {
  /*   const pattern =/\d/
    
    const pos = pattern.test(val.keyCode);

    return pos; */
    const { keyCode } = val
    const pos = (keyCode == 8 || keyCode == 0 || keyCode == 13) ? null : keyCode >= 48 && keyCode <= 57

 return pos;
}




// WEBPACK FOOTER //
// ./src/utils/functions/onlypositivenumbers.js